export default "__VITE_ASSET__CgWG4anZ__"